"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitUntilSnapshotPublishable = exports.waitForSnapshotPublishable = void 0;
const GetAutoTestSnapshotCommand_1 = require("../commands/GetAutoTestSnapshotCommand");
const util_waiter_1 = require("@smithy/util-waiter");
const checkState = async (client, input) => {
    let reason;
    try {
        let result = await client.send(new GetAutoTestSnapshotCommand_1.GetAutoTestSnapshotCommand(input));
        reason = result;
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "errored") {
                return { state: util_waiter_1.WaiterState.FAILURE, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "finished") {
                return { state: util_waiter_1.WaiterState.SUCCESS, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "waiting-to-start") {
                return { state: util_waiter_1.WaiterState.RETRY, reason };
            }
        }
        catch (e) { }
        try {
            let returnComparator = () => {
                return result.snapshot.source.ran.buildProgram.state;
            };
            if (returnComparator() === "running") {
                return { state: util_waiter_1.WaiterState.RETRY, reason };
            }
        }
        catch (e) { }
        return { state: util_waiter_1.WaiterState.SUCCESS, reason };
    }
    catch (exception) {
        reason = exception;
    }
    return { state: util_waiter_1.WaiterState.RETRY, reason };
};
const waitForSnapshotPublishable = async (params, input) => {
    const serviceDefaults = { minDelay: 2, maxDelay: 120 };
    return (0, util_waiter_1.createWaiter)({ ...serviceDefaults, ...params }, input, checkState);
};
exports.waitForSnapshotPublishable = waitForSnapshotPublishable;
const waitUntilSnapshotPublishable = async (params, input) => {
    const serviceDefaults = { minDelay: 2, maxDelay: 120 };
    const result = await (0, util_waiter_1.createWaiter)({ ...serviceDefaults, ...params }, input, checkState);
    return (0, util_waiter_1.checkExceptions)(result);
};
exports.waitUntilSnapshotPublishable = waitUntilSnapshotPublishable;
